export const normalizeSize = (
  value?: string | number | null,
): string | undefined => {
  if (value === undefined || value === null || value === "") return undefined;

  const strValue = String(value).trim();

  if (/[a-z%]+$/i.test(strValue)) return strValue;

  const num = Number(strValue);

  if (!Number.isNaN(num)) return `${num}px`;

  return strValue;
};
